import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { keycloak } from "..";
import { AUTH_MANAGE_API } from "../constants/constants";
import { defaultHeaders } from "../utils/params";
export const authServiceApi = createApi({
  reducerPath: "authEmployeeApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: AUTH_MANAGE_API,
      // prepareHeaders: async (headers, { getState }) => {
      //   const token = (getState() as any)?.auth?.access_token;

      //   if (token) {
      //     headers.set("Authorization", `Bearer ${token}`);
      //   }

      //   headers.set("ngrok-skip-browser-warning", "true");
      //   headers.set("productid", "14");
      //   return headers;
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    // TODO: open when work with api
    // if (
    //   result.error &&
    //   result.error?.status === 401 &&
    //   (result?.error?.data as any)?.message === "Unauthorized"
    // ) {
    //   localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
    //   window.location.reload();
    // }
    if (
      result.error &&
      result.error?.status === 401 &&
      (result?.error?.data as any)?.message === "Unauthorized"
    ) {
      try {
        await keycloak.logout();
        localStorage.clear();
      } catch (err) {
        console.error("Keycloak logout failed:", err);
      }
    }

    return result;
  },
  tagTypes: ["GetAllEmployeesDetails"],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
